import React, { useEffect, useState } from "react";
import "./Contactus.css";
import { Contact } from "../../../Redux/Slices/User";
import { axiosInstance } from "../../../Axios/AxiosInstance";
import SeoHead from "../../Common/SeoHead";
import { PAGE_SEO } from "../../../constants/seo";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaPaperPlane } from "react-icons/fa";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    message: "",
  });
  const [contactDetails, setContactDetails] = useState({
    email: "",
    phone: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Fetch contact details from API
  useEffect(() => {
    axiosInstance
      .get("contact-us")
      .then((response) => {
        setContactDetails(response?.data?.data[0]);
      })
      .catch((error) => {
        console.log(error.message);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await Contact(formData);
    setFormData({
      name: "",
      email: "",
      contact: "",
      message: "",
    });
  };

  return (
    <>
      <SeoHead
        title={PAGE_SEO["/contact"].title}
        description={PAGE_SEO["/contact"].description}
        path="/contact"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Contact Us", path: "/contact" },
        ]}
      />

      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-container">
          <h1 className="contact-hero-title">Get in Touch</h1>
          <p className="contact-hero-subtitle">
            Have questions? We'd love to hear from you. Send us a message and
            we'll respond as soon as possible.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-main">
        <div className="contact-main-container">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <div className="contact-form-card">
                <h2 className="contact-form-title">Send us a Message</h2>
                <form onSubmit={handleSubmit} className="contact-form">
                  <div className="form-group">
                    <label htmlFor="name" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-input"
                      id="name"
                      name="name"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-input"
                      id="email"
                      name="email"
                      placeholder="your.email@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="contact" className="form-label">
                      Contact Number
                    </label>
                    <input
                      type="tel"
                      className="form-input"
                      id="contact"
                      name="contact"
                      placeholder="+91 XXXXX XXXXX"
                      value={formData.contact}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="message" className="form-label">
                      Message
                    </label>
                    <textarea
                      className="form-textarea"
                      id="message"
                      name="message"
                      rows={5}
                      placeholder="Tell us how we can help you..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button type="submit" className="contact-submit-btn">
                    <FaPaperPlane /> Send Message
                  </button>
                </form>
              </div>
            </div>

            {/* Contact Info */}
            <div className="contact-info-wrapper">
              <div className="contact-info-card">
                <h3 className="contact-info-title">Contact Information</h3>
                <p className="contact-info-subtitle">
                  Reach out to us through any of these channels
                </p>

                <div className="contact-info-items">
                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <FaMapMarkerAlt />
                    </div>
                    <div className="contact-info-content">
                      <h4>Address</h4>
                      <p>
                        {contactDetails?.address ||
                          "268/2/B/2 G T Road Liluah Howrah 711204"}
                      </p>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <FaPhoneAlt />
                    </div>
                    <div className="contact-info-content">
                      <h4>Phone</h4>
                      <a href={`tel:${contactDetails?.phone || "700311142"}`}>
                        {contactDetails?.phone || "+91 700311142"}
                      </a>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="contact-info-icon">
                      <FaEnvelope />
                    </div>
                    <div className="contact-info-content">
                      <h4>Email</h4>
                      <a
                        href={`mailto:${
                          contactDetails?.email || "cajobportal@gmail.com"
                        }`}
                      >
                        {contactDetails?.email || "cajobportal@gmail.com"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Info Card */}
              <div className="contact-support-card">
                <h4>Need Quick Assistance?</h4>
                <p>
                  Our support team is available Monday to Friday, 9 AM to 6 PM
                  IST. We typically respond within 24 hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
